"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var Facebook = function Facebook() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M463,141H-49v512h256V429h-64v-64h64v-80c0-26.4,21.6-48,48-48h112v64h-96v64h96l-16,64h-80v224h192V141z"
  }));
};

Facebook.displayName = 'Facebook';
var _default = Facebook;
exports["default"] = _default;
Facebook.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Facebook"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Facebook.js"] = {
    name: "Facebook",
    docgenInfo: Facebook.__docgenInfo,
    path: "src/Facebook.js"
  };
}